const mEditionBillingSalesDataModalActionDisabled = {
  mEditionBillingSalesDataModalActionDisabled: {
    buttonPrimary: 'ENTENDIDO',
    messageAlert: 'Este punto de venta está relacionado con la venta de uno o más productos, para poder desactivarlo de manera global primero debes desactivar su relación de venta.',
    title: 'ACCIÓN DESHABILITADA'
  }
}
export default mEditionBillingSalesDataModalActionDisabled
